import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as authApi from '../../api/auth';
import { getAccessToken } from '../../api/client';
const initialState = {
    user: null,
    isAuthenticated: !!getAccessToken(),
    isNewUser: false,
    loading: false,
    error: null,
};
export const loginWithTelegram = createAsyncThunk('auth/login', async (initData) => {
    return authApi.login(initData);
});
export const fetchMe = createAsyncThunk('auth/fetchMe', async () => {
    return authApi.getMe();
});
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser(state, action) {
            state.user = action.payload;
            state.isAuthenticated = true;
        },
        logout(state) {
            state.user = null;
            state.isAuthenticated = false;
            state.isNewUser = false;
            authApi.logout();
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginWithTelegram.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(loginWithTelegram.fulfilled, (state, action) => {
            state.loading = false;
            state.user = action.payload.user;
            state.isAuthenticated = true;
            state.isNewUser = action.payload.isNewUser;
        })
            .addCase(loginWithTelegram.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'Login failed';
        })
            .addCase(fetchMe.fulfilled, (state, action) => {
            state.user = action.payload;
            state.isAuthenticated = true;
        })
            .addCase(fetchMe.rejected, (state) => {
            state.user = null;
            state.isAuthenticated = false;
        });
    },
});
export const { setUser, logout } = authSlice.actions;
export default authSlice.reducer;
